import React from 'react'
import { SegmentedControlOption } from './SegmentedControl'

interface InsetSegmentedControlProps<T extends string | boolean | null> {
  value: T
  options: Array<SegmentedControlOption<T>>
  onChange: (value: T) => void
  className?: string
  grow?: boolean
}

const activeShadow =
  '0px 2px 4px 0px rgba(0,0,0,0.04), 0px 1px 2px -1px rgba(0,0,0,0.08), 0px 0px 0px 1px rgba(0,0,0,0.08)'

const InsetSegmentedControl = <T extends string | boolean | null>({
  value,
  options,
  onChange,
  className = 'self-stretch',
  grow = true
}: InsetSegmentedControlProps<T>): JSX.Element => {
  return (
    <div
      className={`p-1 bg-backgrounds-bg-disabled rounded-lg outline outline-1 outline-offset-[-1px] outline-borders-border-base inline-flex justify-start items-center gap-px ${className}`}>
      {options.map((option) => {
        const isActive = option.value === value
        return (
          <button
            key={option.value === null ? 'empty' : String(option.value)}
            type="button"
            onClick={() => {
              onChange(option.value)
            }}
            className={`${grow ? 'flex-1' : 'shrink-0'} p-2 rounded-md flex justify-center items-center gap-1.5 ${
              isActive ? 'bg-backgrounds-bg-field-component' : ''
            }`}
            style={isActive ? { boxShadow: activeShadow } : {}}>
            {typeof option.icon === 'object' && option.icon !== null && (
              <div className="size-4 shrink-0 flex items-center justify-center text-foregrounds-fg-muted">
                {option.icon}
              </div>
            )}
            <div
              className={`flex items-center h-4 text-xs font-semibold font-Montserrat leading-4 whitespace-nowrap ${
                isActive ? 'text-foregrounds-fg-base' : 'text-foregrounds-fg-muted'
              }`}>
              {option.label}
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default InsetSegmentedControl
